import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { COLOR_PRIMARY_CONTRAST_500 } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-auth-new-password',
  templateUrl: './auth-new-password.component.html',
  styleUrls: ['./auth-new-password.component.scss'],
})
export class AuthNewPasswordComponent {
  constructor(private meta: Meta) {}

  ngOnInit(): void {
    this.meta.updateTag({ content: COLOR_PRIMARY_CONTRAST_500 }, 'name=theme-color');
  }
}
